/**
 * Directive: tabAnchor
 */
angular.module('acme.common.directive.tabAnchor', [])
.directive('tabAnchor', ['$location', '$anchorScroll', function($location, $anchorScroll) {

    return {
      restrict: 'A',
      link: link
    };

    function link(scope, element, attributes) {
      // update HREF state to use the new tabAnchor value as the embedded fragment.
      attributes.$observe( "tabAnchor", configureHref );

      function configureHref() {
        var fragment = ( attributes.tabAnchor || "" );

        if ( fragment.charAt( 0 ) === "#" ) {
          fragment = fragment.slice( 1 );
        }

        //when clicking on tabs, we need to strip out the previous tabAnchor and then add the new one.
        var routeValue = ( $location.url().split( "#" ).shift() );
        var fragmentValue = ( "#" + fragment );
        attributes.$set( "href", ( routeValue + fragmentValue ) );
      }
    }

}]);